import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import EmployeeSessionBanner from '../components/EmployeeSessionBanner/EmployeeSessionBanner';
import BottomNavigationBar from '../components/BottomNavigationBar/BottomNavigationBar';
import type { ShellRouteContext } from './shellRouteContext';
import { useDeferredSeoFooterMount } from './useDeferredSeoFooterMount';
import './layoutShell.css';

export interface AppShellProps {
  route: ShellRouteContext;
  children: React.ReactNode;
}

/**
 * Chrome mobile : navbar compacte, bottom nav, pas de footer sur certains parcours.
 * Point d'extension pour des layouts 100 % dédiés mobile / Capacitor.
 */
export const MobileShell: React.FC<AppShellProps> = ({ route, children }) => {
  const wantsSeoFooter = !route.shouldHideFooter && route.showMarketingFooterOnMobile;
  const seoFooterMounted = useDeferredSeoFooterMount(wantsSeoFooter, route.pathname);

  return (
    <div
      className={`app-shell app-shell--mobile${route.showNavbar ? ' app-shell--with-navbar' : ''}`}
      data-app-shell="mobile"
      {...(route.showMarketingFooterOnMobile ? { 'data-seo-footer-mobile': 'true' } : {})}
    >
      {route.showNavbar && <Navbar />}
      {route.showEmployeeBanner && <EmployeeSessionBanner />}
      <main className="app-shell__content">{children}</main>
      {wantsSeoFooter && seoFooterMounted ? <Footer /> : null}
      {route.showBottomNav && <BottomNavigationBar />}
    </div>
  );
};
